export default __webpack_public_path__ + "static/media/NeueMontreal-MediumItalic.52989019.woff2";